// extracted by mini-css-extract-plugin
export default {"wrapper":"ShareBar_wrapper__MjFwM","label":"ShareBar_label__P6RRS","body":"ShareBar_body__4dLF6"};